import { useRef } from 'react';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { useI18n } from '../contexts/I18nContext';

const TESTIMONIAL_KEYS = [
  { quoteKey: 'test.q1', roleKey: 'test.role.youth' },
  { quoteKey: 'test.q2', roleKey: 'test.role.parent' },
  { quoteKey: 'test.q3', roleKey: 'test.role.artist' },
  { quoteKey: 'test.q4', roleKey: 'test.role.vendor' },
];

export default function Testimonials() {
  const { t } = useI18n();
  const scroller = useRef(null);

  const scroll = (dir) => {
    const el = scroller.current;
    if (!el) return;
    const amount = el.clientWidth * 0.85;
    el.scrollBy({ left: dir * amount, behavior: 'smooth' });
  };

  return (
    <section className="py-20 lg:py-28 bg-[#FAF3EE]">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <div className="inline-flex items-center gap-2 text-[#E5614C] font-semibold uppercase tracking-[0.18em] text-[12px]">
              <span className="h-[2px] w-8 bg-[#E5614C]" /> {t('home.test.eyebrow')}
            </div>
            <h2 className="font-serif-display text-[40px] sm:text-[48px] lg:text-[56px] leading-[1.05] font-bold text-[#2A1B1A] mt-4">
              {t('home.test.title1')} <span className="italic text-[#5DCAB5]">{t('home.test.title2')}</span>
            </h2>
            <p className="mt-4 text-[16px] text-[#2A1B1A]/70 max-w-xl">
              {t('home.test.subtitle')}
            </p>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => scroll(-1)}
              aria-label="Previous"
              className="h-12 w-12 rounded-full bg-white border border-[#2A1B1A]/10 hover:bg-[#E5614C] hover:text-white hover:border-[#E5614C] transition-colors flex items-center justify-center"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              onClick={() => scroll(1)}
              aria-label="Next"
              className="h-12 w-12 rounded-full bg-white border border-[#2A1B1A]/10 hover:bg-[#E5614C] hover:text-white hover:border-[#E5614C] transition-colors flex items-center justify-center"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div
          ref={scroller}
          className="mt-12 flex gap-6 overflow-x-auto snap-x snap-mandatory pb-6 -mx-5 px-5 md:-mx-10 md:px-10"
          style={{ scrollbarWidth: 'none' }}
        >
          {TESTIMONIAL_KEYS.map((tk, i) => (
            <div
              key={i}
              className="snap-start shrink-0 w-[88%] sm:w-[55%] lg:w-[38%] bg-white rounded-[24px] p-8 lg:p-9 shadow-[0_20px_50px_-30px_rgba(42,27,26,0.3)] border border-[#2A1B1A]/5 hover:shadow-[0_30px_70px_-30px_rgba(229,97,76,0.4)] transition-shadow duration-300"
            >
              <Quote className="h-8 w-8 text-[#E5614C]" />
              <p className="mt-5 text-[17px] leading-relaxed text-[#2A1B1A]/85">
                {t(tk.quoteKey)}
              </p>
              <div className="mt-7 pt-5 border-t border-[#2A1B1A]/8">
                <div className="text-[11px] font-semibold tracking-[0.18em] uppercase text-[#5DCAB5]">
                  {t(tk.roleKey)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
